var map = {
	"./AG.png": 7199,
	"./AI.png": 7808,
	"./AR.png": 8542,
	"./BE.png": 9407,
	"./BL.png": 8526,
	"./BS.png": 8910,
	"./CH.png": 8322,
	"./FR.png": 3310,
	"./GE.png": 2878,
	"./GL.png": 5151,
	"./GR.png": 535,
	"./JU.png": 2397,
	"./LU.png": 5902,
	"./NE.png": 3189,
	"./NW.png": 1768,
	"./OW.png": 8082,
	"./SG.png": 9146,
	"./SH.png": 8258,
	"./SO.png": 9730,
	"./SW.png": 9420,
	"./SZ.png": 1229,
	"./TA.png": 6950,
	"./TG.png": 5871,
	"./TI.png": 7933,
	"./UR.png": 3993,
	"./VD.png": 168,
	"./VS.png": 213,
	"./ZG.png": 6596,
	"./ZH.png": 5148
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8974;